import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Face2Icon(props: IconProps) {
    return <Icon {...props} iconKey={"face_2"}/>
}
